import React from 'react';

const PageLayout = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, children));
};
PageLayout.displayName = 'PageLayout';
var PageLayout$1 = PageLayout;

export { PageLayout$1 as default };
